import { render } from "./ObjectsTable.vue?vue&type=template&id=35f6fff6"
import script from "./ObjectsTable.vue?vue&type=script&lang=js"
export * from "./ObjectsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__